import { useUserEnvironment } from 'store/hooks/useUserEnvironment';

type Args = {
  listingId: string;
};

export function useUserHasAppliedToListing({ listingId }: Args): {
  userHasAppliedToListing: boolean;
} {
  const { user } = useUserEnvironment();

  if (!user) return { userHasAppliedToListing: false };

  const applicationsToListing = user.listingApplications.filter(
    (listingApplication) => listingApplication.id === listingId,
  );

  return { userHasAppliedToListing: applicationsToListing.length > 0 };
}
